import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/sitting-3.svg")